import ViewMediaDialog from './ViewMediaDialog'

export * from './ViewMediaDialog'
export default ViewMediaDialog
